import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routeLabels = {
  '/dashboard': 'Dashboard',
  '/front-desk': 'Front Desk',
  '/calendar': 'Calendar',
  '/reservations': 'Reservations',
  '/groups': 'Groups',
  '/housekeeping': 'Housekeeping',
  '/guests': 'Guests',
  '/night-audit': 'Night Audit',
  '/reports': 'Reports',
  '/settings': 'Settings',
  '/rate-plans': 'Rate Plans',
  '/channel-manager': 'Channel Manager',
  '/revenue-analytics': 'Revenue Analytics',
  '/staff': 'Staff',
  '/maintenance': 'Maintenance',
  '/audit-logs': 'Audit Logs',
  '/accounting': 'Accounting',
  '/communications': 'Communications',
  '/messaging': 'Messaging',
  '/addons': 'Add-ons',
  '/promo-codes': 'Promo Codes',
  '/user-management': 'User Management',
  '/dnr': 'Do Not Rent',
  '/forecasting': 'Forecasting',
  '/export-reports': 'Export Reports',
  '/advanced-analytics': 'Advanced Analytics',
};

const Breadcrumbs = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const label = routeLabels[currentPath] || currentPath.replace('/', '').replace(/-/g, ' ');

  if (currentPath === '/dashboard') return null; // No breadcrumb on home

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-slate-600 mb-4">
      {/* PR #60 — min-h 44px on the link tap target so it meets
          WCAG 2.5.5 AAA. text-slate-500 → text-slate-600 on
          surrounding caption text for AA contrast on white. */}
      <Link
        to="/dashboard"
        className="flex items-center gap-1 hover:text-slate-900 transition-colors min-h-[44px] -my-2 px-1"
      >
        <Home size={16} aria-hidden="true" />
        <span>Dashboard</span>
      </Link>
      <ChevronRight size={14} className="text-slate-500" aria-hidden="true" />
      <span className="text-slate-900 font-medium capitalize">{label}</span>
    </nav>
  );
};

export default Breadcrumbs;
